import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosRequestConfig } from "axios";
import { UserSearchInfo } from "../models/userModel";
import httpClient from "../../utils/httpClient";

export interface ResponseError {
  message: string;
}

export interface RequestObject {
  searchText: string;
}

export const getUserSearchData = createAsyncThunk<
  any,
  RequestObject,
  { rejectValue: ResponseError }
>("UsersSlice/getUserSearchData", async (requestObject, thunkApi) => {
  try {
    const response = await httpClient.post("/users", requestObject, {
      signal: thunkApi.signal,
    } as AxiosRequestConfig);
    if (response.status != 200) {
      if (response.data.Status == "error") {
        return thunkApi.rejectWithValue({
          message: response.data.Message,
        });
      } else {
        return thunkApi.rejectWithValue({
          message: "Failed to fetch search user list.",
        });
      }
    }
    return response.data;
  } catch (error: any) {
    if (thunkApi.signal.aborted) {
      return thunkApi.rejectWithValue({ message: "Request cancelled" });
    }
    return thunkApi.rejectWithValue({
      message: "Failed to fetch search user list.",
    });
  }
});

interface UserListState {
  isLoading: boolean;
  data: UserSearchInfo[] | null;
  error: string | null;
}

const initialState: UserListState = {
  isLoading: false,
  data: null,
  error: null,
};

const UsersSlice = createSlice({
  name: "UsersSlice",
  initialState,
  reducers: {
    resetUserSearchData: (state) => {
      state.isLoading = false;
      state.data = null;
      state.error = null;
    },
  },
  extraReducers(builder) {
    builder.addCase(getUserSearchData.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(getUserSearchData.rejected, (state, { payload }) => {
      state.isLoading = false;
      state.error = payload?.message || "Failed to fetch search user list.";
    });
    builder.addCase(getUserSearchData.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.data = payload || [];
      state.error = null;
    });
  },
});

export const { resetUserSearchData } = UsersSlice.actions;
export default UsersSlice.reducer;
